import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DeviceType } from "../../../utils/constants";
import { useWindowSize } from "../../common/hooks/useWindowSize";
import { detectDeviceType } from "../../common/utils/common";

const MetaContext = React.createContext({
  deviceType: undefined,
  isMobile: false,
  isTab: false,
  isDesktop: false,
  isResponsive: false,
  navigateToPetPulseApp: undefined,
  navigateToPage: undefined,
});

export const useMetaContext = () => useContext(MetaContext);

export const MetaContextProvider = ({ children }) => {
  const [screenWidth] = useWindowSize();
  const [deviceType, setDeviceType] = useState(detectDeviceType());
  const navigate = useNavigate();

  const navigateToPetPulseApp = useCallback(() => {
    window.location.href = 'https://app.petpulse.me';
  }, []);

  const navigateToPage = useCallback(
    (url) => {
      navigate(url);
    },
    [navigate]
  );

  useEffect(() => {
    const newDeviceType = detectDeviceType();
    if (newDeviceType !== deviceType) {
      setDeviceType(newDeviceType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screenWidth]);

  const isMobile = deviceType === DeviceType.mobile;
  const isTab = deviceType === DeviceType.tablet;
  const isDesktop = deviceType === DeviceType.pc;
  const isResponsive = deviceType !== DeviceType.pc;

  return (
    <MetaContext.Provider
      value={{
        deviceType,
        isMobile,
        isTab,
        isDesktop,
        isResponsive,
        navigateToPetPulseApp,
        navigateToPage,
      }}
    >
      {children}
    </MetaContext.Provider>
  );
};
